import React, { useState } from 'react'

import DefaultCarousel from '../../../components/Carousels/DefaultCarousel/index'
import TimelineYears from './_TimelineYears'

import NossaTrajetoriaJSON from '../../assets/data/NossaTrajetoria.json'

import * as S from './style'
type carouselDataProps = {
  id: number;
  year: string;
  description: string;
}

const NossaTrajetoria = () => {
  const [ carouselIndex, setCaroulselIndex ] = useState(0)

  function changeCaroulselSelected (nextSlide: number) {
    setCaroulselIndex(nextSlide)
  }

  return (
    <S.Section className='pt-1'>
      <div className='row mx-0 py-5'>
        <div className='col-12 col-md-11 col-lg-10 col-xl-6 mx-auto align-items-center text-center px-4'>
          <h2 className='font-citrina fs-28 fs-md-40 fs-lg-48 lh-33 lh-md-44 lh-lg-52 fw-500 mb-4'>Trajetória que constrói o futuro</h2>
          <p className='fs-14 fs-md-16 fs-lg-18 lh-16 lh-md-19 lh-lg-22 text-grayscale--500 fw-400'>Nascemos da vontade de fazer diferente. Cada transformação nos fez crescer, inovar e entender que nosso jeito Inter de fazer continua evoluindo junto com o futuro.</p>
        </div>
      </div>
      <div className='line' />
      <div>
        <TimelineYears carouselIndexData={carouselIndex} NossaTrajetoriaJSON={NossaTrajetoriaJSON} />
      </div>
      <div className='col-12 mx-auto px-0 pb-5'>
        <DefaultCarousel
          sm={{
            items: 1,
          }}
          md={{
            items: 1,
          }}
          lg={{
            items: 1,
          }}
          xl={{
            items: 1,
          }}
          beforeChange={(nextSlide: number) => changeCaroulselSelected(nextSlide)}
        >
          {
            NossaTrajetoriaJSON.map((item: carouselDataProps, index: number) => (
              <div className='container' key={index}>
                <div className='row'>
                  <div className='col-9 col-md-8 px-0 mx-auto text-center' key={index}>
                    <S.Desc
                      className='text-grayscale--500 fs-18 lh-22'
                      dangerouslySetInnerHTML={{ __html: `${carouselIndex === item.id ? item.description : ''}` }}
                    />
                  </div>
                </div>
              </div>
            ))
          }
        </DefaultCarousel>
      </div>
    </S.Section>
  )
}

export default NossaTrajetoria
